<ng-container *ngIf="content">
    <div *ngIf="!hideAttachments" class="d-flex flex-col gap-15">
        <ng-container *ngFor="let attachment of this.content?.attachments">
            <div *ngIf="attachment.attachment_type  === 'image' && content.show_attachment_above_text"
                 class="px-16 pt-10">
                <img #image [src]="attachment.file" class="w-100 smallerImg" mat-card-image>
            </div>
        </ng-container>
    </div>

    <mat-card-content class="postContent">
        <div #textContent [class.partial]='!show'>
            <div [innerHTML]="formattedText | mentionFormat" class="innerContent ck-editorControl"></div>
            <button #selectedMenuTrigger [matMenuTriggerFor]="menu" style="height: 0;opacity: 0;width: 0"></button>
            <mat-menu #menu="matMenu" class="userDisplayMenu">
                <ng-container *ngIf="selectedMenuUser">
                    <app-user-info [user]="selectedMenuUser"></app-user-info>
                </ng-container>
            </mat-menu>
        </div>
        <div *ngIf="displayExpandContent" class="w-100 text-center my-10">
            <button (click)="show = !show" color="accent" mat-raised-button>Show
                <ng-container *ngIf="!show">More</ng-container>
                <ng-container *ngIf="show">Less</ng-container>
            </button>
        </div>
    </mat-card-content>
    <div *ngIf="!hideAttachments" class="d-flex flex-col gap-15">
        <div *ngIf="heatmap" class="mt-10 my-10">
            <app-heatmap-vote [heatmap]="heatmap"/>
        </div>

        <ng-container *ngFor="let attachment of this.content?.attachments">

            <ng-container
                    *ngIf="attachment.attachment_type == 'document'">
                <div class="w-100 text-center">
                    <a [href]="attachment.file" color="accent" mat-raised-button target="_blank">View Attachment</a>
                </div>
            </ng-container>
            <video (play)="reportAction()" *ngIf="attachment?.videoUrl" class="youtubeEmbed mt-10 px-16" controls>
                <source *ngIf="this.get_url_extension(attachment.file) == 'WebM' || this.get_url_extension(attachment.file) == 'ogg' else mp4"
                        [src]="attachment.videoUrl" [type]="'video/'  + this.get_url_extension(attachment.file)">
                Your browser does not support the video tag.
                <ng-template #mp4>
                    <source [src]="attachment.videoUrl" [type]="'video/mp4'">
                </ng-template>
            </video>
            <iframe (iframeClick)="reportAction(attachment.url)"
                    *ngIf="(attachment.safeVideoLink && !attachment.isApiUrl) || attachment.safeImageLink"
                    [src]="attachment.safeVideoLink || attachment.safeImageLink"
                    allow="encrypted-media; web-share; autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                    appHideGiphyOverlay
                    appIframeTracker
                    appResizableIframe
                    class="youtubeEmbed mt-10 px-16"
                    frameborder="0"
                    height="auto" referrerpolicy="strict-origin-when-cross-origin"></iframe>

            <video (play)="reportAction(attachment.url)" *ngIf="attachment.safeVideoLink && attachment.isApiUrl"
                   [src]="attachment.safeVideoLink"
                   class="youtubeEmbed mt-10 px-16"
                   controls></video>
            <div *ngIf="attachment.attachment_type  === 'image' && !content.show_attachment_above_text"
                 class="px-16 pt-10">
                <img #image [src]="attachment.file" class="w-100 smallerImg" mat-card-image>
            </div>
            <div *ngIf="attachment.attachment_type  === 'audio'"
                 class="px-16 pt-10">
                <app-audio-player [file]="attachment.file"></app-audio-player>
            </div>
            <div *ngIf="attachment?.attachment_type == 'survey_url' && this.currentUser?.id && this.content?.id"
                 class="flex-col justify-content-center mt-10 align-items-center">
                <div [matTooltip]="this.surveyCompleted? (this.hasCommunityRole(['member']) || this.isSuperUser()?'Survey already completed': 'Current user role cannot complete surveys') : 'Click to complete a survey'">
                    <button (click)="openSurvey(attachment?.url + '?id=' + this.currentUser?.id + '&survey=' + this.content?.id)"
                            [disabled]="this.surveyCompleted" color="primary"
                            data-id="{{this.currentUser?.id}} {{this.content?.id}} "
                            mat-raised-button>
                        Start Survey
                    </button>
                </div>
            </div>
            <div *ngIf="attachment?.attachment_type == 'url'" class="flex-row justify-content-center mt-10">
                <a [href]="attachment?.url" color="primary" mat-raised-button target="_blank">
                    View
                </a>
            </div>
        </ng-container>
    </div>
</ng-container>
